

import { useEffect } from "react"
import { Testimonials as Testimonial, Grid } from "../components"
import { Navbar, Footer } from "../layouts"




const Testimonials = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])

    return (
        <>
        <Navbar/>
        <Grid/>
        <Testimonial/>
        <Footer/>
        </>

    )
}


export default Testimonials